import Page from "webPage/Page";
import ProductFilters from "util/ProductFilters";
import {handleTestimonialSlider} from "util/Testimonials";

Page.register(["post-type-archive-product", "tax-product_cat"], () => {
    new ProductFilters($('.js-products'));

    handleTestimonialSlider();
});
